<div class="container-fluid inst-configs-page">
  <div class="d-flex mt-4 align-items-center mb-2">
    <h1 class="dashboard-heading ms-2 mb-0">Institution Configs</h1>
  </div>
  <hr class="page-divider">

  <section class="inst-filter-card card shadow-sm">
    <div class="card-body py-3">
      <div class="row g-3 align-items-end">
        <div class="col-md-3">
          <label class="form-label inst-label">Environment</label>
          <select class="form-select" [(ngModel)]="selectedEnvironment">
            <option value="" disabled>Select Environment</option>
            <option *ngFor="let env of environments" [value]="env">{{ env.toUpperCase() }}</option>
          </select>
        </div>

        <div class="col-md-3" *ngIf="selectedEnvironment && requiresRegion(selectedEnvironment)">
          <label class="form-label inst-label">Region</label>
          <select class="form-select" [(ngModel)]="selectedRegion">
            <option value="" disabled>Select Region</option>
            <option *ngFor="let reg of regions" [value]="reg">{{ reg.toUpperCase() }}</option>
          </select>
        </div>

        <div class="col-md-4">
          <label class="form-label inst-label">Institution Code</label>
          <input mdbInput type="search"
                 class="form-control"
                 placeholder="Enter Institution Code"
                 [(ngModel)]="filterText"
                 (keydown)="onEnterKey($event)"
                 [disabled]="!selectedEnvironment || (requiresRegion(selectedEnvironment) && !selectedRegion)">
        </div>

        <div class="col-md-2 d-grid">
          <button class="btn btn-primary inst-search-btn"
                  (click)="searchInstitutions()"
                  [disabled]="!selectedEnvironment || (requiresRegion(selectedEnvironment) && !selectedRegion)">
            <i class="fa fa-search me-1"></i> Search
          </button>
        </div>
      </div>
    </div>
  </section>

  <section *ngIf="institutionConfig" class="inst-results-card card shadow-sm">
    <div class="inst-results-header">
      <div>
        <h2 class="inst-results-title mb-0">Application Data</h2>
        <p *ngIf="institutionList.length > 0" class="inst-results-subtitle mb-0">
          {{ institutionList.length }} application(s) found
        </p>
        <div class="inst-results-meta">
          <span class="inst-meta-label">Institution ID</span>
          <span class="inst-meta-value">{{ institutionConfig.institutionId }}</span>
        </div>
      </div>
      <span *ngIf="institutionList.length > 0" class="inst-count-badge">{{ institutionList.length }}</span>
    </div>

    <div *ngIf="institutionList.length > 0" class="table-container position-relative" [ngClass]="loading ? 'blur-background' : ''">
      <div *ngIf="loading" class="inst-table-loader">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <table class="table inst-configs-table mb-0">
        <thead>
        <tr>
          <th class="col-expand" scope="col" aria-label="Expand row"></th>
          <th scope="col">App Name</th>
          <th scope="col">Narration</th>
          <th scope="col">App Key</th>
          <th scope="col">App Secret</th>
          <th scope="col" class="col-public-key">Public Key</th>
        </tr>
        </thead>
        <tbody>
        <ng-container *ngFor="let item of institutionList; let i = index">
          <tr class="inst-data-row" [class.inst-data-row--expanded]="isRowExpanded(i)">
            <td class="col-expand">
              <button type="button"
                      class="btn btn-sm inst-expand-btn"
                      (click)="toggleRowExpand(i)"
                      [attr.aria-expanded]="isRowExpanded(i)"
                      [attr.aria-label]="isRowExpanded(i) ? 'Hide details' : 'Show details'">
                <i class="fa" [ngClass]="isRowExpanded(i) ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
              </button>
            </td>
            <td class="col-text" [title]="item.appName">{{ displayValue(item.appName) }}</td>
            <td class="col-text col-narration" [title]="getNarration(item)">{{ displayValue(getNarration(item)) }}</td>
            <td class="col-text" [title]="item.appKey">{{ displayValue(item.appKey) }}</td>
            <td class="col-text col-secret" [title]="item.appSecret">{{ displayValue(item.appSecret) }}</td>
            <td class="col-key col-public-key">
              <div class="key-cell">
                <ng-container *ngIf="item.publicKey; else emptyKey">
                  <span class="key-preview-mini" [title]="item.publicKey">{{ getKeyPreview(item.publicKey, true) }}</span>
                  <button type="button"
                          class="btn btn-sm inst-key-action-btn inst-primary"
                          (click)="copyToClipboard(item.publicKey, 'Public key')"
                          title="Copy public key">
                    <i class="fa fa-copy"></i>
                  </button>
                </ng-container>
              </div>
            </td>
          </tr>

          <tr *ngIf="isRowExpanded(i)" class="inst-detail-row">
            <td [attr.colspan]="getTableColSpan()">
              <div class="inst-detail-panel">
                <p class="inst-detail-title">
                  <i class="fa fa-key me-2"></i>Full details — {{ displayValue(item.appName) }}
                </p>
                <div class="inst-detail-grid">
                  <div class="inst-detail-field">
                    <span class="inst-field-label">App Name</span>
                    <div class="inst-field-value-wrap">
                      <span class="inst-field-value">{{ displayValue(item.appName) }}</span>
                    </div>
                  </div>

                  <div class="inst-detail-field">
                    <span class="inst-field-label">Narration</span>
                    <div class="inst-field-value-wrap">
                      <span class="inst-field-value">{{ displayValue(getNarration(item)) }}</span>
                    </div>
                  </div>

                  <div class="inst-detail-field">
                    <span class="inst-field-label">App Key</span>
                    <div class="inst-field-value-wrap">
                      <span class="inst-field-value">{{ displayValue(item.appKey) }}</span>
                      <button *ngIf="item.appKey" type="button" class="btn btn-sm inst-copy-btn"
                              (click)="copyToClipboard(item.appKey, 'App key')" title="Copy app key">
                        <i class="fa fa-copy"></i>
                      </button>
                    </div>
                  </div>

                  <div class="inst-detail-field">
                    <span class="inst-field-label">App Secret</span>
                    <div class="inst-field-value-wrap">
                      <span class="inst-field-value">{{ displayValue(item.appSecret) }}</span>
                      <button *ngIf="item.appSecret" type="button" class="btn btn-sm inst-copy-btn"
                              (click)="copyToClipboard(item.appSecret, 'App secret')" title="Copy app secret">
                        <i class="fa fa-copy"></i>
                      </button>
                    </div>
                  </div>

                  <div class="inst-detail-field inst-detail-field--wide">
                    <span class="inst-field-label">Public Key</span>
                    <div class="inst-field-value-wrap inst-field-value-wrap--long">
                      <span class="inst-field-value inst-field-value--mono">{{ displayValue(item.publicKey) }}</span>
                      <button *ngIf="item.publicKey" type="button" class="btn btn-sm inst-copy-btn"
                              (click)="copyToClipboard(item.publicKey, 'Public key')" title="Copy public key">
                        <i class="fa fa-copy"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </ng-container>
        </tbody>
      </table>
    </div>

    <div *ngIf="institutionList.length > 0" class="inst-results-footer">
      <i class="fa fa-info-circle me-1"></i>
      Click the arrow to view full keys. Hover a preview for the complete value.
    </div>

    <div *ngIf="institutionList.length === 0" class="inst-empty-inline">
      <i class="fa fa-inbox inst-empty-icon me-2"></i>
      No application keys found for this institution.
    </div>
  </section>

  <ng-template #emptyKey>
    <span class="inst-empty-value">—</span>
  </ng-template>

  <div *ngIf="copiedText" class="inst-toast" role="status">{{ copiedText }}</div>
</div>
